import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCountryById, defaultCountryData, updateCountry, createCountry } from '@/api/locations/countries';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultCountryData);
    this.loading = false;
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter Country',
        trigger: 'blur'
      }, {
        min: 2,
        max: 100,
        message: 'Length should be 2 to 100',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: 'Please enter code',
        trigger: 'blur'
      }, {
        min: 2,
        max: 3,
        message: 'Length should be 2 to 3',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultCountryData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getCountryById(id);
      this.formData = data;
      // Just for test
      const title = this.formData.name;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await updateCountry(this.formData.id, this.formData);
      } else {
        await createCountry(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Country saved',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/countries/list',
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'CountryDetail',
  components: {}
})], default_1);
export default default_1;